import './UserTabItemTypeSelector.scss';

import React from 'react';

import {
  Radio,
  Tooltip,
  Typography,
} from 'antd';

import { numFormatterInUnit } from '../../../shared/formatter';
import {
  UserProfileTabItemTypeValue,
} from '../../../types/tqConnectTypes/user';

interface Props {
  item: 'Reviews' | 'Shoutouts';
  selectedType: UserProfileTabItemTypeValue;
  onSelectType: (type: UserProfileTabItemTypeValue) => void;
  receivedCount?: number;
  givenCount?: number;
}

const UserTabItemTypeSelector: React.FC<Props> = ({
  item,
  selectedType,
  onSelectType,
  receivedCount = 50,
  givenCount = 50,
}) => {
  return (
    <Radio.Group
      value={selectedType || 'received'}
      onChange={(e) => onSelectType(e.target.value)}
      className="item-type__selector accountSettingsTab">
      <Radio.Button
        value="received"
        className="selector__item accountSettingsTabItem">
        <Tooltip title={`${item} received`}>
          <Typography.Text className="selector__item__text">
            Received{' '}
            {receivedCount ? `(${numFormatterInUnit(receivedCount)})` : ''}
          </Typography.Text>
        </Tooltip>
      </Radio.Button>

      <Radio.Button
        value="given"
        className="selector__item accountSettingsTabItem">
        <Tooltip title={`${item} given`}>
          <Typography.Text className="selector__item__text">
            Given {givenCount ? `(${numFormatterInUnit(givenCount)})` : ''}
          </Typography.Text>
        </Tooltip>
      </Radio.Button>
    </Radio.Group>
  );
};

export default UserTabItemTypeSelector;
